import { Button } from '@framework/ui/atoms/Button';
import { Modal } from '@framework/ui/elements';

type Props = {
  isOpen: boolean;
  onClose(): void;
};

export const ApplyLicenseThanksModal: React.FC<Props> = ({ isOpen, onClose }: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="mx-8" style={{ height: '320px' }}>
        <div className={'p-3 text-xl'}>ライセンスの申し込み</div>
        <div className="pt-8">
          ありがとうございました。
          <br />
          <br />
          後日、ご入力いただいたメールアドレスに請求書を送付いたします。
        </div>
        <div className={'flex justify-center pt-20'}>
          <div className={'pr-2'}>
            <Button color="secondary" onClick={onClose}>
              閉じる
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
